import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { CatalogView } from "@/features/courses/components/catalog/catalog-view";

export const catalogRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/catalog",
  component: CatalogView,
});
